import 'apps/admin/styles/components/groups-manager.scss';
import React from 'react';
import { Link, Redirect } from 'library/util/core-router';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import withData from 'util/hoc/with-data';
import Query from 'apps/admin/util/query';
import Toggle from 'library/components/form-elements/toggle';
import SavingButton from 'library/components/saving-button';
import { jsonToInputParams } from 'library/util/graph';
import ApplicantList from 'apps/admin/components/applicant-list';
import OpeningToggle from 'apps/admin/components/opening-toggle';
import Confirm from 'library/helpers/confirm';
import GenerateDataExportModal from 'apps/admin/components/generate-data-export-modal';

const GenerateReport = (props) => (
  <button style={{justifyContent: 'center'}} {...props}>
    Generate Report
  </button>
);

class GroupsManager extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    graph_data: PropTypes.object.isRequired,
    graph_loading: PropTypes.bool.isRequired,
    reload_graph: PropTypes.func.isRequired,
    connectable_id: PropTypes.number.isRequired
  }

  state = {
    form_data: {
      ti: null,
      ti_inherit: null
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    let currentGroup = resolve(nextProps.graph_data, 'organization/ti_info_tree', []);

    const path = resolve(nextProps.match, 'params/path', '').split('/').filter(c=>c).map(c=>Number(c));
    const parent_sublicense = {
      id: null,
      sublicense: ''
    };
    if (resolve(currentGroup, 'children_inherit_sublicense', false) && resolve(currentGroup, 'ti_sublicense_id', null)) {
      parent_sublicense.id = currentGroup.id;
      parent_sublicense.sublicense = resolve(currentGroup, 'ti_sublicense_id', '');
    }

    for (const id of path) {
      currentGroup = resolve(currentGroup, 'children', []).find(c=>c.id===id);
      if (resolve(currentGroup, 'children_inherit_sublicense', false) && resolve(currentGroup, 'ti_sublicense_id', null)) {
        parent_sublicense.id = currentGroup.id;
        parent_sublicense.sublicense = resolve(currentGroup, 'ti_sublicense_id', '');
      }
    }

    const out = {
      parentSublicense: parent_sublicense,
      currentGroup: currentGroup
    };

    if (resolve(currentGroup, 'id', null)!==resolve(prevState, 'currentGroup/id', null)) {
      out.form_data = {
        ti: null,
        ti_inherit: null
      };
    }

    return out;
  }

  mapChildren = (child) => (
    <Link
      key={child.id}
      className="admin-groups-subgroup"
      to={['/admin/organizations', this.props.connectable_id, 'groups', resolve(this.props, 'match/params/path', ''),child.id].filter(c=>c).join('/')}
    >
      { child.name }
    </Link>
  )

  getArchiveStatus = (id) => {

  }

  handleChange = (e) => {
    const { value, name } = e.target;

    const form_data = this.state.form_data;
    form_data[name] = value;
    this.setState({
      form_data: form_data
    });
  }

  get hasChanges() {
    return Object.values(resolve(this.state, `form_data`, {})).findIndex(v=>v!==null) > -1;
  }

  save = async () => {
    this.setState({
      saving: true
    });

    const params = {
      id: this.state.currentGroup.id,
      ti_settings: {
        sublicense_id: this.state.form_data.ti,
        children_inherit_sublicense: this.state.form_data.ti_inherit
      }
    };

    try {
      const { data } = await Query(`
        mutation {
          update_ti_node (${jsonToInputParams(params)}) {
            success
          }
        }
      `);

      if (resolve(data, 'update_ti_node/success', false)) {
        await this.props.reload_graph(true, true);
      }
    } catch (e) {
      console.error(e);
    }

    this.setState({
      saving: false
    });
  }

  deleteTi = async () => {
    const { currentGroup } = this.state;
    const groupId = resolve(currentGroup, 'id', null );

    if(!groupId) return;

    if(await Confirm('Are you sure?', { children: <p>Allison, Are you sure you want to destroy this organizations TI Sublicense? 😱 </p> })) {
      try {
        const { data } = await Query(`
          mutation {
            destroy_ti_settings(id: ${groupId}) {
              success,
              errors
            }
          }`);
        data.destroy_ti_settings.success ? this.props.reload_graph(true) : alert(data.destroy_ti_settings.errors.toString());
      } catch (e) {
        console.error(e);
      }
    }

  }

  GetSublicenseId = (currentGroup, parent_sublicense) => {
    if (resolve(currentGroup, 'ti_sublicense_id', '') === parent_sublicense) {
      return '';
    }
    return resolve(currentGroup, 'ti_sublicense_id', '')||'';
  }

  render() {
    const {
      graph_loading,
      match,
      connectable_id
    } = this.props;

    const {
      form_data,
      saving,
      currentGroup,
      parentSublicense
    } = this.state;

    if (graph_loading) {
      return <h1>Loading</h1>;
    }

    if (!currentGroup) {
      return <Redirect to={back_url} />;
    }

    const type = resolve(currentGroup, 'type', '').split('::');
    const bottom_type = type[type.length -1];

    const path = resolve(match, 'params/path', '').split('/').filter(c=>c).map(c=>Number(c));
    const back_url = `/admin/organizations/${connectable_id}/groups/${path.slice(0, -1).join('/')}`;

    return (
      <div className="admin-groups">
        <div className="admin-groups-header">
          <h1>{resolve(currentGroup, 'name', '--NO-NAME--')}</h1>
          {
            path.length
              ? <Link to={back_url}>Go Back</Link>
              : null
          }
        </div>
        <h3>Settings</h3>
        {
          bottom_type == 'Opening'
            ? <OpeningToggle id={resolve(currentGroup, 'id', null)} />
            : null
        }
        <div className="admin-groups-settings">
          <label>
          Group Data Export
            <GenerateDataExportModal
              organization_id={String(connectable_id)}
              node_id={currentGroup.id}
              component={GenerateReport}
            />
          </label>
          <div className="admin-ti-sublicense">
            <label>
              TI Sublicense ID
              <input
                type="text"
                name="ti"
                onChange={this.handleChange}
                value={
                  resolve(form_data, 'ti', null)===null
                    ? this.GetSublicenseId(currentGroup, parentSublicense)
                    : resolve(form_data, 'ti', '')
                }
                placeholder={parentSublicense.sublicense}
                disabled={saving}
              >
              </input>
              <button onClick={this.deleteTi}> delete </button>
            </label>
          </div>
          <label>
            Children Inherit TI Sublicense
            <Toggle
              name="ti_inherit"
              checked={resolve(form_data, 'ti_inherit', null)===null?resolve(currentGroup, 'children_inherit_sublicense', false):resolve(form_data, 'ti_inherit', '')}
              onChange={this.handleChange}
              disabled={saving}
            />
          </label>
          <SavingButton disabled={!this.hasChanges} saving={saving} onClick={this.save}>
            Save
          </SavingButton>


        </div>
        <h3>Sub Groups</h3>
        <div className="admin-groups-subgroups">
          { resolve(currentGroup, 'children', []).map(this.mapChildren) }
        </div>
        {bottom_type == 'Opening' ?
          <div className='admin-groups-applicants'>
            <ApplicantList id={resolve(currentGroup, 'id', null)} />
          </div>
          :
          null
        }
      </div>
    );
  }
}

GroupsManager.query = async (token, { connectable_id }) => (
  Query(`
    {
      organization (id:${connectable_id}){
        ti_info_tree
      }
    }
  `)
);

export default withData(GroupsManager);
